<template>
  <section>
    <router-view></router-view>
  </section>
</template>

<script>
// // import { sofbox } from '@/config/pluginInit';

export default {
  name: 'BlankLayout',
  // mounted() {
  //   sofbox.mainIndex();
  // },
};
</script>
